import { API_CONFIG } from '../config/config';

// Global HTTP interceptor for handling authentication errors
class HTTPInterceptor {
  constructor() {
    this.authContext = null;
    this.setupGlobalFetchInterceptor();
  }

  // Set the auth context reference
  setAuthContext(authContext) {
    this.authContext = authContext;
  }

  // Setup global fetch interceptor
  setupGlobalFetchInterceptor() {
    const originalFetch = window.fetch;
    
    window.fetch = async (url, options = {}) => {
      try {
        const response = await originalFetch(url, options);
        
        // Check for 401 Unauthorized responses
        if (response.status === 401) {
          console.log('401 Unauthorized response detected, triggering logout');
          
          // Handle token invalidation
          if (this.authContext && this.authContext.handleTokenInvalidation) {
            await this.authContext.handleTokenInvalidation('Sitzung abgelaufen oder ungültig');
          } else {
            // Fallback: redirect to login page
            console.log('No auth context available, redirecting to login');
            window.location.href = '/login';
          }
        }
        
        return response;
      } catch (error) {
        // Handle network errors that might indicate token issues
        if (error.message && error.message.includes('401')) {
          console.log('401 error in fetch, triggering logout');
          
          if (this.authContext && this.authContext.handleTokenInvalidation) {
            await this.authContext.handleTokenInvalidation('Netzwerkfehler - Sitzung ungültig');
          } else {
            window.location.href = '/login';
          }
        }
        
        throw error;
      }
    };
  }

  // Check if current token is valid
  async checkTokenValidity() {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/auth/validate`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.log('Token validation failed, triggering logout');
        if (this.authContext && this.authContext.handleTokenInvalidation) {
          await this.authContext.handleTokenInvalidation('Token-Validierung fehlgeschlagen');
        } else {
          window.location.href = '/login';
        }
        return false;
      }

      return true;
    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  }

  // Periodic token validation
  startPeriodicValidation(intervalMs = 60000) { // Check every minute
    setInterval(async () => {
      const token = localStorage.getItem('token');
      if (token && this.authContext) {
        await this.checkTokenValidity();
      }
    }, intervalMs);
  }
}

// Create singleton instance
const httpInterceptor = new HTTPInterceptor();

export default httpInterceptor;
